import { InviteToTeamComponent } from './inviteToTeam.component';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ProfileComponent } from './profile.component';
import { GeneralModule } from '../general/general.module';
import { DirectivesModule } from '../directives/directives.module';
import { AdminComponent } from './admin.component';
import { CreditCardFormComponent } from './creditCardForm.component';
import { PaymentEditorDialogComponent } from './paymentEditorDialog.component';
import { SubscriptionPlanComponent } from './subscriptionPlan.component';
import { ManageBriefingsListPaneComponent } from './manageBriefingsListPane.component';
import { ManageBriefingsComponent } from '../briefings/manageBriefings.component';
import { EditBriefingPaneComponent } from './editBriefingPane.component';
import { TopicSelectorDialogComponent } from './topicSelectorDialog.component';
import { TopicSelectionListComponent } from './topicSelectionList.component';
import { BriefingScheduleEditorComponent } from './briefingScheduleEditor.component';
import { BriefingSettingsEditorComponent } from './briefingSettingsEditor.component';
import { BriefingSlackSettingsEditorComponent } from './briefingSlackSettingsEditor.component';
import { BriefingTopicsEditorComponent } from './briefingTopicsEditor.component';
import { CreateBriefingPaneComponent } from './createBriefingPane.component';
import { BriefingEditorComponent } from './briefingEditor.component';
import { BriefingHistoryComponent } from './briefingHistory.component';
import { SourceManagerComponent } from './sourceManagement.component';
import { StreamListComponent } from './streamList.component';
import { SourceAggregationComponent } from './sourceAggregation.component';
import { SourceTopicsComponent } from './sourceTopics.component';
import { StartCreateSourceComponent } from './startCreateSource.component';
import { CreateSourceRootComponent } from './createSourceRoot.component';
import { CreateSourceComponent } from './createSource.component';
import { CreateRssSourceComponent } from './createRssSource.component';
import { CreateSourcePreviewResultsComponent } from './createSourcePreviewResults.component';
import { CreateTwitterSourceComponent } from './createTwitterSource.component';
import { CreateBingSourceComponent } from './createBingSource.component';
import { CreatePubMedSourceComponent } from './createPubMedSource.component';
import { CreateFactivaSelectSourceComponent } from './createFactivaSelectSource.component';
import { CreateClinicalTrialsSourceComponent } from './createClinicalTrialsSource.component';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { ImportOpmlComponent } from './importOpml.component';
import { RssChangeSourceDialogComponent } from './rssChangeSourceDialog.component';
import { FactivaChangeSourceDialogComponent } from './factivaChangeSourceDialog.component';
import { BingChangeSourceDialogComponent } from './bingChangeSourceDialog.component';
import { PubmedChangeSourceDialogComponent } from './pubmedChangeSourceDialog.component';
import { ClinicalTrialsChangeSourceDialogComponent } from './clinicalTrialsChangeSourceDialog.component';
import { TwitterChangeSourceDialogComponent } from './twitterChangeSourceDialog.component';
import { AccountComponent } from './account.component';
import { GroupsModule } from '../groups/groups.module';
import { UserSubscriptionComponent } from './userSubscription.component';
import { BriefingHistoryDetailsDialogComponent } from './briefingHistoryDetailsDialog.component';
import { BriefingMembersComponent } from './briefingMembers.component';
import { SelectMultipleBriefingMembersDialogComponent } from './selectMultipleBriefingMembersDialog.component';
import { BriefingPreviewDialogComponent } from './briefingPreviewDialog.component';
import { BriefingGroupsComponent } from './briefingGroups.component';
import { SelectBriefingGroupsDialogComponent } from './selectBriefingGroupsDialog.component';
import { AttensaEditorModule } from '../attensaEditor/attensaEditor.module';
import { ReadingModule } from '../reading/reading.module';
import { NavigationModule } from '../navigation/navigation.module';
import { CreateScopusSourceComponent } from './createScopusSearchSource.component';
import { ScopusChangeSourceDialogComponent } from './scopusChangeSourceDialog.component';
import { CreateDiffbotSourceComponent } from './createDiffbotSearchSource.component';
import { DiffbotChangeSourceDialogComponent } from './diffbotChangeSourceDialog.component';
import { BriefingTeamsSettingsEditorComponent } from './briefingTeamsSettingsEditor.component';
import { CatalogListComponent } from './catalogList.component';
import { CatalogEditComponent } from './catalogEdit.component';
import { CatalogEditStreamsComponent } from './catalogEditStreams.component';
import { CreateCatalogDialogComponent } from './createCatalogDialog.component';
import { CatalogAddSourcesComponent } from './catalogAddSources.component';
import { CategoryManagementComponent } from './categoryManagement.component';
import { AddCategoryDialogComponent } from './addCategoryDialog.component';
import { SharedSourceListComponent } from './sharedSourceList.component';
import { SharedTopicListComponent } from './sharedTopicList.component';
import { SharedTagListComponent } from './sharedTagList.component';
import { SharedTagEditComponent } from './sharedTagEdit.component';
import { PersonalBriefingsManagerComponent } from './personalBriefingsManager.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
    imports: [
        AttensaEditorModule,
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        GroupsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MaterialFileInputModule,
        MomentModule,
        NavigationModule,
        PipesModule,
        ReadingModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    providers: [
        DatePipe,
    ],
    declarations: [
        AccountComponent,
        AddCategoryDialogComponent,
        AdminComponent,
        BingChangeSourceDialogComponent,
        BriefingEditorComponent,
        BriefingGroupsComponent,
        BriefingHistoryComponent,
        BriefingHistoryDetailsDialogComponent,
        BriefingMembersComponent,
        BriefingPreviewDialogComponent,
        BriefingScheduleEditorComponent,
        BriefingSettingsEditorComponent,
        BriefingSlackSettingsEditorComponent,
        BriefingTeamsSettingsEditorComponent,
        BriefingTopicsEditorComponent,
        CatalogAddSourcesComponent,
        CategoryManagementComponent,
        CatalogEditComponent,
        CatalogEditStreamsComponent,
        CatalogListComponent,
        ClinicalTrialsChangeSourceDialogComponent,
        CreateBingSourceComponent,
        CreateBriefingPaneComponent,
        CreateCatalogDialogComponent,
        CreateClinicalTrialsSourceComponent,
        CreateDiffbotSourceComponent,
        CreatePubMedSourceComponent,
        CreateScopusSourceComponent,
        CreateFactivaSelectSourceComponent,
        CreateRssSourceComponent,
        CreateSourceComponent,
        CreateSourcePreviewResultsComponent,
        CreateSourceRootComponent,
        CreateTwitterSourceComponent,
        CreditCardFormComponent,
        DiffbotChangeSourceDialogComponent,
        EditBriefingPaneComponent,
        FactivaChangeSourceDialogComponent,
        ImportOpmlComponent,
        InviteToTeamComponent,
        ManageBriefingsComponent,
        ManageBriefingsListPaneComponent,
        PersonalBriefingsManagerComponent,
        PaymentEditorDialogComponent,
        ProfileComponent,
        PubmedChangeSourceDialogComponent,
        RssChangeSourceDialogComponent,
        ScopusChangeSourceDialogComponent,
        SelectMultipleBriefingMembersDialogComponent,
        SelectBriefingGroupsDialogComponent,
        SharedSourceListComponent,
        SharedTopicListComponent,
        SharedTagListComponent,
        SharedTagEditComponent,
        StartCreateSourceComponent,
        SourceAggregationComponent,
        StreamListComponent,
        SourceManagerComponent,
        SourceTopicsComponent,
        SubscriptionPlanComponent,
        TopicSelectorDialogComponent,
        TopicSelectionListComponent,
        TwitterChangeSourceDialogComponent,
        UserSubscriptionComponent
    ],
    exports: [
        AccountComponent,
        AdminComponent,
        BingChangeSourceDialogComponent,
        ClinicalTrialsChangeSourceDialogComponent,
        CreateBingSourceComponent,
        CreateBriefingPaneComponent,
        CreateClinicalTrialsSourceComponent,
        CreatePubMedSourceComponent,
        CreateFactivaSelectSourceComponent,
        CreateRssSourceComponent,
        CreateSourceComponent,
        CreateSourcePreviewResultsComponent,
        CreateSourceRootComponent,
        CreateTwitterSourceComponent,
        DiffbotChangeSourceDialogComponent,
        EditBriefingPaneComponent,
        FactivaChangeSourceDialogComponent,
        ImportOpmlComponent,
        InviteToTeamComponent,
        ManageBriefingsComponent,
        ManageBriefingsListPaneComponent,
        PersonalBriefingsManagerComponent,
        ProfileComponent,
        PubmedChangeSourceDialogComponent,
        RssChangeSourceDialogComponent,
        ScopusChangeSourceDialogComponent,
        SharedSourceListComponent,
        SharedTopicListComponent,
        SharedTagListComponent,
        SharedTagEditComponent,
        StartCreateSourceComponent,
        SourceAggregationComponent,
        StreamListComponent,
        SourceManagerComponent,
        SourceTopicsComponent,
        SubscriptionPlanComponent,
        TopicSelectorDialogComponent,
        TwitterChangeSourceDialogComponent,
        UserSubscriptionComponent
    ],
    entryComponents: [
        BingChangeSourceDialogComponent,
        BriefingHistoryDetailsDialogComponent,
        BriefingPreviewDialogComponent,
        ClinicalTrialsChangeSourceDialogComponent,
        CreateCatalogDialogComponent,
        DiffbotChangeSourceDialogComponent,
        FactivaChangeSourceDialogComponent,
        PaymentEditorDialogComponent,
        PubmedChangeSourceDialogComponent,
        RssChangeSourceDialogComponent,
        ScopusChangeSourceDialogComponent,
        SelectMultipleBriefingMembersDialogComponent,
        SelectBriefingGroupsDialogComponent,
        TopicSelectorDialogComponent,
        TwitterChangeSourceDialogComponent
    ]
})
export class SettingsModule {
}